import { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { AppleLogo, GooglePlayLogo } from 'phosphor-react';
import '../css/HomePage.css';

const APP_STORE_URL = 'https://apps.apple.com/us/app/family-ring/id6504144806';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.famring.membox';

function getPlatform() {
  const ua = navigator.userAgent || '';
  if (/iPhone|iPad|iPod/i.test(ua)) return 'ios';
  if (/Android/i.test(ua)) return 'android';
  return 'desktop';
}

function InstallPage() {
  const [platform, setPlatform] = useState(null);

  useEffect(() => {
    const detected = getPlatform();
    setPlatform(detected);

    if (detected === 'ios') {
      window.gtag?.('event', 'install_redirect', {
        event_category: 'Install',
        event_label: 'iOS Auto-Redirect',
        transport_type: 'beacon'
      });
      window.location.href = APP_STORE_URL;
    }

    if (detected === 'android') {
      window.gtag?.('event', 'install_redirect', {
        event_category: 'Install',
        event_label: 'Android Auto-Redirect',
        transport_type: 'beacon'
      });
      window.location.href = PLAY_STORE_URL;
    }
  }, []);

  if (platform === 'ios') {
    return (
      <section className="py-5">
        <Container className="text-center">
          <p className="text-muted">Redirecting to the App Store...</p>
        </Container>
      </section>
    );
  }

  if (platform === 'android') {
    return (
      <section className="py-5">
        <Container className="text-center">
          <p className="text-muted">Redirecting to Google Play...</p>
        </Container>
      </section>
    );
  }

  return (
    <section className="py-5">
      <Container className="text-center">
        <img
          src="/brand/applogo-1024.png"
          alt="Family Ring"
          style={{ maxWidth: 120, marginBottom: 24 }}
        />
        <h2 className="mb-3">Install Family Ring!</h2>
        <p className="text-muted mb-4">
          Download the app on your phone to get started.
        </p>
        <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center mb-4">
          <a
            className="download-badge apple"
            href={APP_STORE_URL}
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              window.gtag?.('event', 'install_click', {
                event_category: 'Install',
                event_label: 'App Store Link (Desktop)',
                transport_type: 'beacon'
              });
            }}
          >
            <AppleLogo size={36} weight="fill" />
            <div className="download-badge-text">
              <small>Download on the</small>
              <span>App Store</span>
            </div>
          </a>
          <a
            className="download-badge google"
            href={PLAY_STORE_URL}
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              window.gtag?.('event', 'install_click', {
                event_category: 'Install',
                event_label: 'Google Play Link (Desktop)',
                transport_type: 'beacon'
              });
            }}
          >
            <GooglePlayLogo size={36} weight="fill" />
            <div className="download-badge-text">
              <small>Get it on</small>
              <span>Google Play</span>
            </div>
          </a>
        </div>
        <p className="text-muted">
          Questions? <a href="mailto:support@familyring.io">support@familyring.io</a>
        </p>
      </Container>
    </section>
  );
}

export default InstallPage;
